/** @format */

import { HmfMediaSetItem } from '@dsg-tech/homefield-utils';
import { Injectable } from '@angular/core';

export interface ProductImagePictureSource {
  media?: string;
  srcSet: string;
  type?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProductImageService {
  static getProductImageSourceSet(mediaSetItem: HmfMediaSetItem): ProductImagePictureSource[] {
    const scene7LgPxWidParam = '1100';
    const scene7MedPxWidParam = '992';
    const scene7SmPxWidParam = '780';
    const scene7DefPxWidParam = '600';
    return [
      {
        media: '(min-width: 1200px)',
        type: 'image/webp',
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7LgPxWidParam}&hei=${scene7LgPxWidParam}&fmt=webp&op_sharpen=1&fit=constrain`,
      },
      {
        media: '(min-width: 1200px)',
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7LgPxWidParam}&hei=${scene7LgPxWidParam}&fmt=pjpeg&op_sharpen=1&fit=constrain`,
      },
      {
        media: '(min-width: 992px)',
        type: 'image/webp',
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7MedPxWidParam}&hei=${scene7MedPxWidParam}&fmt=webp&op_sharpen=1&fit=constrain`,
      },
      {
        media: '(min-width: 992px)',
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7MedPxWidParam}&hei=${scene7MedPxWidParam}&fmt=pjpeg&op_sharpen=1&fit=constrain`,
      },
      {
        media: '(min-width: 768px)',
        type: 'image/webp',
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7SmPxWidParam}&hei=${scene7SmPxWidParam}&fmt=webp&op_sharpen=1&fit=constrain`,
      },
      {
        media: '(min-width: 768px)',
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7SmPxWidParam}&hei=${scene7SmPxWidParam}&fmt=pjpeg&op_sharpen=1&fit=constrain`,
      },
      {
        type: 'image/webp',
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7DefPxWidParam}&hei=${scene7DefPxWidParam}&fmt=webp&op_sharpen=1&fit=constrain`,
      },
      {
        srcSet: `${mediaSetItem.templateSrc || mediaSetItem.poster}?qlt=70&wid=${scene7DefPxWidParam}&hei=${scene7DefPxWidParam}&fmt=pjpeg&op_sharpen=1&fit=constrain`,
      },
    ];
  }

  static getHeroImageDimensionsForScene7(): string {
    const screenWidth = window.screen.width;

    if (screenWidth >= 1200) {
      return '1100';
    }

    if (screenWidth >= 992) {
      return '992';
    }

    return '780';
  }
}
